import React from 'react';
import '../less/main.less';
import DOMPurify from 'utils/sanitize';
import { ReactSVG } from 'react-svg';
import btn_icon from '../img/btn_icon.svg';
import TooltipNew from '../../TooltipNew';

export default function template() {
    const {items, title, btnLink, btnText, onBtnClick, page, btnId, titleTag = 'h2', subtitle} = this.props;

    const showButton = btnText && (btnLink || onBtnClick);

    const Tag = titleTag;
    
    return (
      <div className="how-to-block-new">
        <div className="container">
          {(title || subtitle) && (
            <div className="how-to-block-new__top">
              {title && <Tag className="how-to-block-new__title">{this.l10n(title)}</Tag>}
              {subtitle && <div className="how-to-block-new__subtitle">{this.l10n(subtitle)}</div>}
            </div>
          )}
          <div className={`how-to-block-new__items how-to-block-new__items_${items.length}`}>
            {items.map((item, index) => (
              <div className={`how-to-block-new__item item-how-to-block-new${item.tooltip ? ' item-how-to-block-new_with-tooltip' : ''}`} key={index}>
                <div className={`item-how-to-block-new__top ${item.reversedImg ? 'with-padding-bottom': ''}`}>
                  <img className="item-how-to-block-new__image" src={item.img} alt={item.alt ? this.l10n(item.alt) : ''} />
                </div>
                <div className="item-how-to-block-new__bottom">
                  <div className="item-how-to-block-new__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.title))}}></div>
                  <div className="item-how-to-block-new__text">
                    <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.text))}}></span>
                    {item.link && (
                      <span
                        className="item-how-to-block-new__link"
                        onClick={item.link.onClick}
                        onKeyDown={(e) => e.key === 'Enter' && item.link.onClick}
                        tabIndex="0"
                      >
                        {this.l10n(item.link.text)}
                      </span>
                    )}
                    {item.tooltip && (
                      <TooltipNew>
                        {this.l10n(item.tooltip)}
                      </TooltipNew>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {showButton && (
            btnLink ? (
              <a
                className="how-to-block-new__btn btn-how-to-block-new"
                href={btnLink}
                target="_blank"
                rel="noopener noreferrer"
                id={`${page ? page : ''} how-to-button ${btnId ? btnId : ''}`}
              >
                <ReactSVG src={btn_icon} className="btn-how-to-block-new__image" />
                <span className="btn-how-to-block-new__text">
                  {this.l10n(btnText)}
                </span>
              </a>
            ) : (
              <button
                type="button"
                className="how-to-block-new__btn btn-how-to-block-new"
                onClick={onBtnClick}
                id={`${page ? page : ''} how-to-button ${btnId ? btnId : ''}`}
              >
                <ReactSVG src={btn_icon} className="btn-how-to-block-new__image" />
                <span className="btn-how-to-block-new__text">
                  {this.l10n(btnText)}
                </span>
              </button>
            )
          )}
        </div>
      </div>
    );
}
